<!-- <template>
  <div>
    <van-nav-bar
        title="数据查询"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    <van-tabs>
    <van-tab v-for="item in titleList" :key="item.index" :title="item.title">
        <cardPool v-if="item.index == '1'"/>
        <applyInfo v-if="item.index == '2'"/>
        <overdue v-if="item.index == '3'"/>
        <plateInStock v-if="item.index == '4'"/>
        <cardPocardPoolol v-if="item.index == '5'"/>
    </van-tab>
</van-tabs>
  </div>
</template>

<script>
import {Tab,Tabs} from 'vant'
import cardPool from '@/components/query/cardPool.vue'
import applyInfo from '@/components/query/applyInfo.vue'
import overdue from '@/components/query/overdueIndex.vue'
import plateInStock from '@/components/query/plateInStock.vue'
export default {
    components:{
        cardPool,
        applyInfo,
        overdue,
        plateInStock
    },
    data(){
        return{
            titleList:[
                {'index':'1','title':'申请次数'},
                {'index':'2','title':'申请信息'},
                {'index':'3','title':'逾期未取'},
                {'index':'4','title':'存储位置'},
                {'index':'5','title':'历史记录'},
            ]
        }
    },
    methods:{
        goBack(){
            this.$router.push('/home')
        }
    }
}
</script>

<style lang="scss">
.divClass{
    width: 100px;
    height: 100px;
    margin: 0 auto;
    background-color: skyblue;
}
</style> -->

<template>
    <div>
      <table border="1">
        <thead>
          <tr>
            <th v-for="(value, date) in tableData[0]" :key="date">{{ date }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(station, index) in tableData" :key="index">
            <td>{{ station['服务站名称'] }}</td>
            <td v-for="(value, date) in station" :key="date" v-if="date !== '服务站名称'">{{ value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // 这里是你提供的表格数据
        tableData: [
          {
            "服务站名称": "东腾机动车登记服务站",
            "2024-11-20": 92,
            "2024-11-21": 86,
            "2024-11-22": 97,
            "2024-11-23": 0,
            "2024-11-24": 0
          },
          {
            "服务站名称": "冀中合力机动车登记服务站",
            "2024-11-20": 0,
            "2024-11-21": 0,
            "2024-11-22": 0,
            "2024-11-23": 0,
            "2024-11-24": 0
          },
          {
            "服务站名称": "冀安机动车登记服务站",
            "2024-11-20": 157,
            "2024-11-21": 128,
            "2024-11-22": 15,
            "2024-11-23": 0,
            "2024-11-24": 0
          }
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    padding: 8px;
    text-align: center;
  }
  </style>